export const ALERT_TYPES = {
    SUCCESS: 'success',
    DANGER: 'danger'
}

export const WEEK_DAYS = {
    LUNDI: 'lundi',
    MARDI: 'mardi',
    MERCERDI: 'mercredi',
    JEUDI: 'jeudi',
    VENDREDI: 'vendredi'
}

export const RECLAMATION_TYPES = {
    "104": "Contrat de travail",
    "105": "Rémunération / Bulletins de salaire",
    "106": "Planning",
    "107": "Missions (déroulement des missions, relations clients)",
    "108": "Absences (arrêt de travail, maladie, congés)",
    "109": "Documents de fin de contrat",
    "110": "Formation",
    "111": "Mutuelle",
    "112": "Relation / Communication agence",
    "113": "Autres",
}

export const SCHEDULE_EVENT_COLORS = [
    "#800080", "#696969", "#8b4513", "#2e8b57", "#006400",
    "#8b0000", "#808000", "#483d8b", "#008080", "#4682b4",
    "#000080", "#b03060", "#ff4500", "#8a2be2", "#dc143c",
    "#0000ff", "#ff00ff", "#1e90ff", "#ff1493",
]

export const FILE_ERROR = {
    MAX_SIZE: 'max_size',
    INVALID_MIME: 'invalid_mime'
}

export const LEAVE_REQUEST_STATUSES = {
    CANCEL: 4,
    WAIT_FOR_VALIDATION: 1,
    REFUSE: 5,
    DELETED: 6,
    VALIDATED: 2,
    VALIDATED_PENDING_CANCELLATION: 3
}

export const LEAVE_REQUEST_TYPE = {
    CONGES_PAYES: 1,
    CONGES_SANS_SOLDE: 2,
    CONGES_MATERNITE: 3,
    CONGES_PATERNITE: 4,
    CONGES_PARENTAL: 5,
    CONGES_EXCEPTIONNELS_MARIAGE_PACS: 6,
    CONGES_EXCEPTIONNELS_MARIAGE_PACS_UN_ENFANT: 7,
    CONGES_EXCEPTIONNELS_DECES_ENFANT: 8,
    CONGES_EXCEPTIONNELS_DECES_DU_CONJOINT:9,
    CONGES_EXCEPTIONNELS_DECES_PROCHE:10,
    CONGES_EXCEPTIONNELS_DECES_NAISSANCE_ADOPTION:11


}

export const IMAGE_MIME_TYPES = ['image/jpeg', 'image/gif', 'image/png']


export const COMPONENT_KEYWORD = {
    DOCUMENTS_WELCOME_KIT: 'documents-welcome-kit',
    TELEGESTION_IMAGE:'telegestion-image',
    TELEGESTION_URL_PLAYSTORE_IOS: 'telegestion-url-playstore-ios',
    TELEGESTION_URL_PLAYSTORE_ANDROID: 'telegestion-url-playstore-android',
    CONFIRMATION_REQUEST_IMAGE_WEB:"confirmation-request-image",
    QUESTION_IMAGE_WEB: "question-image",
    REFUSED_IMAGE_WEB:"refused-image",
    FORGOT_PWD_EMAIL_INPUT_IMAGE: 'forgot-pwd-email-input-image',
    FORGOT_PWD_EMAIL_SENT_IMAGE: 'orgot-pwd-email-sent-image',

}

export const CONDITION_KEY = {
    LEAVE_REQUEST_CANCELABLE: 'rcfleaverequestcancel'
};


export const CANDIDATURE_MESSAGE = {
    VIVIER_NOT_INTERESTED_BUTTON: 'vivier-not-interested-button',
    VIVIER_STILL_INTERESTED_TEXT: 'vivier-still-interested-text',
    VIVIER_ERROR_CONTENT: 'vivier-error-content',
    VIVIER_UNKNOWN_ERROR_TEXT: 'vivier-unknown-error-text'
}

export const RELANCE_CANDIDATURE_MESSAGE = {
    RELANCE_NOT_INTERESTED_BUTTON: 'relance-not-interested-button',
    RELANCE_STILL_INTERESTED_TEXT: 'relance-still-interested-text',
    RELANCE_ERROR_CONTENT: 'relance-error-content',
    RELANCE_UNKNOWN_ERROR_TEXT: 'relance-unknown-error-text'
}

export const SCREEN_NAME = {
    FORGOT_PASSWORD: 'ForgotPassword',
    EMAIL_SENT: 'EmailSent',
    PROFILE_INFOS_LOGIN: 'ProfilInfosLogin',
    PASSWORD_MODIFIED: 'PasswordModified',
    AN_ERROR_OCCURRED: 'AnErrorOccurred',
}

export const EVENT_NAME = {
    RECLAMATION_SENT: 'ReclamationEquipeRH-MessageSent',
    RECLAMATION_KO: 'ReclamationEquipeRH-MessageKO',
    CLIC_SERVICE_RH_MEDIATION_ENVOYER: 'c_employeeRHMediation_Envoyer',
}
